import { Button, type ButtonProps } from '@src/components/Button/Button';
import { ChevronLeftIcon } from '@src/components/icons/ChevronLeftIcon';
import { ChevronRightIcon } from '@src/components/icons/ChevronRightIcon';
import './ThemeNavigationButton.css';

type Props = Omit<ButtonProps, 'children' | 'icon' | 'variant' | 'size'> & {
  direction: 'previous' | 'next';
  'aria-label': string;
};

/** Landscape navigation with shared button behavior and active-season styling. */
export function ThemeNavigationButton({ direction, className = '', ...props }: Props) {
  const icon = direction === 'previous' ? <ChevronLeftIcon /> : <ChevronRightIcon />;
  return <Button {...props} variant="ghost" size="medium" icon={icon}
    className={`theme-navigation-button ${className}`} />;
}
